import React from 'react';

const FallingStarLogo = ({ size = 32 }) => (
  <img
    src="https://i.imgur.com/3QwoFVw.png"
    alt="xceller."
    width={size}
    height={size}
    style={{
      objectFit: 'contain',
      pointerEvents: 'none',
      userSelect: 'none',
    }}
  />
);

export default FallingStarLogo;
